// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"398":"4f034e44","1531":"77fa3850","1620":"e05f890f","2030":"25a81cde","4056":"25a81cde"}[chunkId] + ".css";
};